import { render, staticRenderFns } from "./indexTwo.vue?vue&type=template&id=ada0df68&scoped=true"
import script from "./indexTwo.vue?vue&type=script&lang=js"
export * from "./indexTwo.vue?vue&type=script&lang=js"
import style0 from "./indexTwo.vue?vue&type=style&index=0&id=ada0df68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0df68",
  null
  
)

export default component.exports